import { Dispatch, SetStateAction, useMemo, useState } from 'react';
import { createSafeContext } from '@mews/framework';
import { Role } from '@mews-commander/data-access';

interface RoleContextProps {
    activeRole: Role | null;
    closeRoleDetail: () => void;
    activeTab: EditRoleTabs;
    setActiveTab: Dispatch<SetStateAction<EditRoleTabs>>;
    openRoleDetail: ({ role, users }: { role: Role; users?: boolean }) => void;
}

export enum EditRoleTabs {
    Settings = 'Settings',
    Users = 'Users',
}

const { RoleContextProvider, useRoleContext } = createSafeContext<'RoleContext', RoleContextProps>('RoleContext');

export const RolesProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
    const [activeRole, setActiveRole] = useState<Role | null>(null);
    const [activeTab, setActiveTab] = useState<EditRoleTabs>(EditRoleTabs.Settings);

    const contextValue = useMemo<RoleContextProps>(
        () => ({
            activeRole,
            closeRoleDetail: () => setActiveRole(null),
            openRoleDetail: ({ role, users }: { role: Role; users?: boolean }) => {
                setActiveRole(role);
                setActiveTab(users ? EditRoleTabs.Users : EditRoleTabs.Settings);
            },
            activeTab,
            setActiveTab,
        }),
        [activeRole, activeTab]
    );

    return <RoleContextProvider value={contextValue}>{children}</RoleContextProvider>;
};

export { useRoleContext };
